import React from 'react';
import { RoomType } from '../../../types.ts';

interface RoomRateProps {
  room: RoomType;
  field: 'FromRate';
}

const RoomRate: React.FC<RoomRateProps> = ({ room, field }) => {
  const formatCurrency = (amount: number, currencyCode: string) => {
    if (!amount) return null;
    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <span>
      {room.Availability[0][field] &&
        room.Availability[0].CurrencyCode &&
        formatCurrency(room.Availability[0][field], room.Availability[0].CurrencyCode)}
    </span>
  );
};

export default RoomRate;
